import React from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import AllStudentsPage from '../pages/AllStudentsPage';
import StudentDashboardPage from '../pages/StudentDashboardPage';
import StartTestPage from '../pages/StartTestPage';
import ProtectedRoute from './ProtectedRoute';
import TestTakingPage from '../pages/TestTakingPage';
import ResultsPage from '../pages/ResultsPage';
import ProfilePage from '../pages/ProfilePage';
import ProgressPage from '../pages/ProgressPage';
import PracticePage from '../pages/PracticePage';
import CheckoutPage from '../pages/CheckoutPage';
import StorePage from '../pages/StorePage';
import VerifyCertificatePage from '../pages/VerifyCertificatePage';
import AuthRedirect from './AuthRedirect';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: (
      <AuthRedirect students={<LoginPage />} />
    ),
  },
  {
    path: '/select-student',
    element: (
      <ProtectedRoute students={<AllStudentsPage />} />
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute students={<StudentDashboardPage />} />
    ),
  },
  {
    path: '/profile',
    element: (
      <ProtectedRoute students={<ProfilePage />} />
    ),
  },
  {
    // Streaks and badges (#11) alongside the score trend (#12).
    path: '/progress',
    element: (
      <ProtectedRoute students={<ProgressPage />} />
    ),
  },
  {
    // Adaptive practice (#03).
    path: '/practice',
    element: (
      <ProtectedRoute students={<PracticePage />} />
    ),
  },
  {
    // The storefront (#10). Package SKUs are bought from here.
    path: '/store',
    element: (
      <ProtectedRoute students={<StorePage />} />
    ),
  },
  {
    // Checkout for a paid SKU, e.g. /checkout?sku=solutions.
    path: '/checkout',
    element: (
      <ProtectedRoute students={<CheckoutPage />} />
    ),
  },
  {
    path: '/start-test',
    element: (
      <ProtectedRoute students={<StartTestPage />} />
    ),
  },
  {
    path: '/test-taking',
    element: (
      <ProtectedRoute students={<TestTakingPage />} />
    ),
  },
  {
    path: '/test-results',
    element: (
      <ProtectedRoute students={<ResultsPage />} />
    ),
  },
  {
    // Public by design (#04): the audience is someone holding a printed certificate
    // who has no account. Putting this behind ProtectedRoute would make a certificate
    // unverifiable by exactly the people it exists to convince.
    path: '/verify/:hash',
    element: <VerifyCertificatePage />,
  },
  {
    // Anything unrecognised goes to the dashboard, which itself sends a signed-out
    // visitor to login.
    //
    // Without this, /test/1 and /results — near-misses for the real /test-taking and
    // /test-results — matched no route and rendered a blank white page to anyone who
    // typed or bookmarked them, signed in or not (EXP-04, EXP-05). A student whose
    // session dropped mid-exam and retyped the URL got a white screen with no way back,
    // which is the worst moment for the app to say nothing at all.
    path: '*',
    element: <Navigate to="/dashboard" replace />,
  },
];
